import { DATE_SHORT_FORMAT } from '../../../../../constants/date'
import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../../constants/rentalPortal'
import { getListingUnitLabel } from '../../../../RentalPortalListing'
import { formatDate } from '../../../../Table'

export function getApplicantsBoardCardMeta({ applicant, locale, t, timezone }) {
  return [
    getListingUnitLabel({ listing: applicant.listing, t }),
    t(applicant.source),
    formatDate({
      date: applicant.received_at,
      dateFormat: DATE_SHORT_FORMAT,
      locale,
      timezone,
      useTodayFormat: false,
    }),
  ]
    .filter(Boolean)
    .join(RENTAL_PORTAL_FACT_SEPARATOR)
}
